import React, { useState, useEffect, Fragment, useContext } from "react";
import Layout from "components/sales/layout/layout";
import TableSection from "components/sales/tableSection/tableSection";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import { Button } from "react-bootstrap";
import Images from "assets/images/imageData";
import localization from "assets/localization/localization";
import ModalPop from "components/sales/modal/modal";
import ListFilters from "components/sales/ListFilters/ListFilters";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

const CommissionPayoutCasesList = ({
  match,
  commissionPayoutCasesRequest,
  commissionPayoutResponse = [],
  validateInvoiceStatus,
  validateStatusResponse = [],
  previewInvoiceRequest,
  previewInvoiceResponse = [],
  raiseInvoiceWithReconRequest,
  raiseInvoiceResponse = [],
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const { baseUrl } = useContext(BaseUrl);
  const [listData, setListData] = useState();
  const [id, setId] = useState("");
  const [roleId, setRoleId] = useState();
  const [userId, setUserId] = useState();
  const [selectedIds, setSelectedIds] = useState([]);
  const [showFilter, setShowFilter] = useState(false);
  const [filterData, setFilterData] = useState(null);
  const [isModal, setIsModal] = useState(false);
  const [isModalSuccess, setIsModalSuccess] = useState(false);
  const [invoiceNumber, setInvoiceNumber] = useState("");
  const [invoiceLink, setInvoiceLink] = useState("");
  const [previewButton, setPreviewButton] = useState(false);

  useEffect(() => {
    (async () => {
      setRoleId(window.localStorage.getItem("fusion-role"));
      setUserId(JSON.parse(window.localStorage.loginDetails)?.id);
      setIsLoading(true);
      const res = await commissionPayoutCasesRequest(1, "REQUEST_FOR_PAYOUT_RELEASE");
      if(res.status !== 200){
        toast.error(res.message);
      }
      setIsLoading(false);
    })();
  }, []);

  const onPageChange = async (val) => {
    setIsLoading(true);
    const res = await commissionPayoutCasesRequest(
      val.selected + 1,
      "REQUEST_FOR_PAYOUT_RELEASE"
    );
    if(res.status !== 200){
      toast.error(res.message);
    }
    setIsLoading(false);
  };

  const headers = [
    "Select",
    "Vehicle Number",
    "Dealer Name",
    "Bank Name",
    "Loan Type",
    "Loan Amount",
    "Net Disbursal Amount",
    "Status",
    "",
  ];

  useEffect(() => {
    if (
      commissionPayoutResponse &&
      commissionPayoutResponse?.data &&
      commissionPayoutResponse?.data?.data &&
      commissionPayoutResponse?.data?.data?.resultSets &&
      commissionPayoutResponse?.data?.data?.resultSets.length > 0
    ) {
      const tableData = [
        "checkbox_select",
        "vehicle_registration_number",
        "dealer_name",
        "bank_name",
        "loan_type",
        "loan_required_amount",
        "loan_approved_amount",
        "status",
        "id",
      ];

      const data = commissionPayoutResponse?.data?.data?.resultSets.map((element) => {
        const row = Object.assign(
          ...tableData.map((key) => ({ [key]: element[key] }))
        );

        return row;
      });

      setListData(data);

      setPageCount(
        Math.ceil(
          commissionPayoutResponse?.data?.data?.total /
            commissionPayoutResponse?.data?.data?.per_page
        )
      );
    }
  }, [commissionPayoutResponse]);

  const handleCheckboxChange = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  const handlePreviewInvoice = () => {
    const request = {
      loan_application_ids: selectedIds,
    };

    (async () => {
      setIsLoading(true);
      const response = await validateInvoiceStatus(request);
      if (response?.status === 1) {
        toast.error(response?.message);
      } else {
        const previewResponse = await previewInvoiceRequest(request);
        if (previewResponse?.status === 1) {
          toast.error(previewInvoiceResponse?.message);
        } else {
          setInvoiceLink(previewInvoiceResponse?.data?.pdf_link);
          setIsModal(true);
        }
      }
      setIsLoading(false);
    })();
  };

  const handleModalHide = () => setIsModal(false);

  const applyFilter = async (filterData) => {
    localStorage.setItem(
      "commission_payout_filter",
      JSON.stringify(filterData)
    );
    setListData([]);
    setIsLoading(true);
    setFilterData(filterData);
    const res = await commissionPayoutCasesRequest(
      1,
      "REQUEST_FOR_PAYOUT_RELEASE",
      filterData
    );
    if(res.status !== 200){
      toast.error(res.message);
    }
    setIsLoading(false);
    filterToggle();
  };

  useEffect(() => {
    if (selectedIds.length > 0) {
      setPreviewButton(true);
    } else {
      setPreviewButton(false);
    }
  }, [selectedIds]);

  const headerBtns = () => {
    return (
      <Fragment>
        {previewButton && (
          <Button
            onClick={handlePreviewInvoice}
            className="filter-hamburger show-btn btn btn-transparent"
          >
            {"Preview Invoice"}
          </Button>
        )}
        <Button
          onClick={filterToggle}
          className="filter-hamburger show-btn btn btn-transparent"
        >
          {" "}
          <img src={Images?.Filter} alt="" />
          {localization.showFilters}
        </Button>
      </Fragment>
    );
  };

  const handleInvoiceRaise = async () => {
    const request = {
      loan_application_ids: selectedIds,
    };
    setIsModal(false); 
    setIsLoading(true); 
  
    const res = await raiseInvoiceWithReconRequest(request);
    console.log('res', res);
  
    if (res?.status === 200) {
      setIsModalSuccess(true); 
    } else {
      toast.error(res?.message || "Something went wrong");
    }
  
    setIsLoading(false); 
  };
  

  const handleSuccessModalHide = () => setIsModalSuccess(false);

  return (
    <>
      <Layout
        title={"Commission Payout Cases"}
        isLoading={isLoading}
        isGoback={true}
        Buttons={headerBtns}
      >
        <TableSection
          data={listData}
          isId={false}
          headers={headers}
          pageCount={pageCount}
          onPageChange={onPageChange}
          detailList={commissionPayoutResponse?.data?.data?.resultSets}
          srNo={commissionPayoutResponse?.data?.data?.from}
          selectedIds={selectedIds}
          onCheckboxChange={handleCheckboxChange}
        />
        <ListFilters
          showFilter={showFilter}
          filterToggle={filterToggle}
          applyFilter={(val) => applyFilter(val)}
          commissionPayoutFilter={true}
          localstorageKey={"commission_payout_filter"}
        />
        <ModalPop
          title={localization.previewInvoice}
          show={isModal}
          handleModalHide={handleModalHide}
          keyboard
          backdrop
        >
        {previewInvoiceResponse?.data?.pdf_link ? (
          <>
          <div className="pdf-preview-container">
            <iframe
              src={previewInvoiceResponse?.data?.pdf_link ?? "No PDF found!"}
              title="Invoice PDF"
              width="100%"
              height="500px"
              style={{ border: "none", marginBottom: "1rem" }}
            />
            <div className="d-flex" style={{ justifyContent: "end" }}>
              <button
                className="btn btn-danger btn-sm mr-3"
                onClick={handleModalHide}
              >
                Discard
              </button>
              <button
                className="btn btn-success btn-sm"
                onClick={handleInvoiceRaise}
              >
                Raise
              </button>
            </div>
          </div>
          </>
        ) : (
          <>
          <h3>{previewInvoiceResponse?.message}</h3>
          </>
        )}
        </ModalPop>
        <ModalPop
          title={localization.conf}
          show={isModalSuccess}
          handleModalHide={handleSuccessModalHide}
          keyboard
          backdrop
        >
          <div className="text-center">
            <div className="success">
              <img src={Images?.tick} alt="" />
            </div>
            <h5>{"Invoice raised successfully"}</h5>
          </div>
        </ModalPop>
        
      </Layout>
    </>
  );
};

export default CommissionPayoutCasesList;
